//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all notifications for user.
 * @param isRead (optional) Filter for getting read or unread notifications.
 * @param studyId (optional) Filter by StudyId.
If value is not defined all notifications from whole studies will be returned.
 * @param types (optional) Filter by types
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getNotifications(isRead?: boolean | null | undefined, studyId?: number | null | undefined, types?: Types.NotificationType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfNotificationDto> {
    let url_ = getBaseUrl() + "/api/notifications?";
    if (isRead !== undefined && isRead !== null)
        url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
    if (studyId !== undefined && studyId !== null)
        url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
    if (types !== undefined && types !== null)
        types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetNotifications,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetNotifications(_response);
    });
}

function processGetNotifications(response: AxiosResponse): Promise<Types.PagedResultOfNotificationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfNotificationDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfNotificationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfNotificationDto>(null as any);
}

/**
 * Mark all notifications as read.
 * @param studyId (optional) 
 */
export function readAllNotifications(studyId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/notifications?";
    if (studyId !== undefined && studyId !== null)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReadAllNotifications,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReadAllNotifications(_response);
    });
}

function processReadAllNotifications(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get notification batches that can be used to display to a user
one notification instead of many ones of the same type
 * @param types (optional) 
 * @param studyIds (optional) 
 * @param isSent (optional) 
 * @param isRead (optional) 
 * @param deliveryTypes (optional) 
 */
export function getNotificationBatches(types?: Types.NotificationType[] | null | undefined, studyIds?: number[] | null | undefined, isSent?: boolean | null | undefined, isRead?: boolean | null | undefined, deliveryTypes?: Types.NotificationDeliveryType[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.NotificationBatchDto[]> {
    let url_ = getBaseUrl() + "/api/notifications/batches?";
    if (types !== undefined && types !== null)
        types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
    if (studyIds !== undefined && studyIds !== null)
        studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
    if (isSent !== undefined && isSent !== null)
        url_ += "IsSent=" + encodeURIComponent("" + isSent) + "&";
    if (isRead !== undefined && isRead !== null)
        url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
    if (deliveryTypes !== undefined && deliveryTypes !== null)
        deliveryTypes && deliveryTypes.forEach(item => { url_ += "DeliveryTypes=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetNotificationBatches,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetNotificationBatches(_response);
    });
}

function processGetNotificationBatches(response: AxiosResponse): Promise<Types.NotificationBatchDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.NotificationBatchDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.NotificationBatchDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.NotificationBatchDto[]>(null as any);
}

/**
 * Get counts of notifications for current user
 * @param studyId (optional) Id of the study that the notifications must relate to
 * @return Counts of notifications grouped by type
 */
export function getNotificationCounts(studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.NotificationCountsByTypeDto[]> {
    let url_ = getBaseUrl() + "/api/notifications/counts?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetNotificationCounts,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetNotificationCounts(_response);
    });
}

function processGetNotificationCounts(response: AxiosResponse): Promise<Types.NotificationCountsByTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.NotificationCountsByTypeDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.NotificationCountsByTypeDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.NotificationCountsByTypeDto[]>(null as any);
}

/**
 * Mark specific notification as read.
 */
export function readNotification(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/notifications/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReadNotification,
        ...config,
        method: "PATCH",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReadNotification(_response);
    });
}

function processReadNotification(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get list of mobile (FCM) tokens for current user.
 */
export function getPushTokens(config?: AxiosRequestConfig | undefined): Promise<Types.UserPushTokenDto[]> {
    let url_ = getBaseUrl() + "/api/notifications/tokens";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPushTokens,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPushTokens(_response);
    });
}

function processGetPushTokens(response: AxiosResponse): Promise<Types.UserPushTokenDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.UserPushTokenDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.UserPushTokenDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserPushTokenDto[]>(null as any);
}

/**
 * Saves push notification token and corresponding information for current user.
 * @param dto DTO.
 */
export function savePushToken(dto: Types.SendPushTokenDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/notifications/token";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavePushToken,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavePushToken(_response);
    });
}

function processSavePushToken(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes (unsubscribe) push token from server.
After that user will not get any pushes for the device where push token is assigned.
 * @param token (optional) FCM token.
 */
export function deletePushToken(token?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/notifications/token?";
    if (token === null)
        throw new Error("The parameter 'token' cannot be null.");
    else if (token !== undefined)
        url_ += "token=" + encodeURIComponent("" + token) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeletePushToken,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeletePushToken(_response);
    });
}

function processDeletePushToken(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetNotifications: Partial<AxiosRequestConfig> | null;
export function getGetNotificationsRequestConfig() {
  return _requestConfigGetNotifications;
}
export function setGetNotificationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetNotifications = value;
}
export function patchGetNotificationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetNotifications = patch(_requestConfigGetNotifications ?? {});
}

let _requestConfigReadAllNotifications: Partial<AxiosRequestConfig> | null;
export function getReadAllNotificationsRequestConfig() {
  return _requestConfigReadAllNotifications;
}
export function setReadAllNotificationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReadAllNotifications = value;
}
export function patchReadAllNotificationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReadAllNotifications = patch(_requestConfigReadAllNotifications ?? {});
}

let _requestConfigGetNotificationBatches: Partial<AxiosRequestConfig> | null;
export function getGetNotificationBatchesRequestConfig() {
  return _requestConfigGetNotificationBatches;
}
export function setGetNotificationBatchesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetNotificationBatches = value;
}
export function patchGetNotificationBatchesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetNotificationBatches = patch(_requestConfigGetNotificationBatches ?? {});
}

let _requestConfigGetNotificationCounts: Partial<AxiosRequestConfig> | null;
export function getGetNotificationCountsRequestConfig() {
  return _requestConfigGetNotificationCounts;
}
export function setGetNotificationCountsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetNotificationCounts = value;
}
export function patchGetNotificationCountsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetNotificationCounts = patch(_requestConfigGetNotificationCounts ?? {});
}

let _requestConfigReadNotification: Partial<AxiosRequestConfig> | null;
export function getReadNotificationRequestConfig() {
  return _requestConfigReadNotification;
}
export function setReadNotificationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReadNotification = value;
}
export function patchReadNotificationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReadNotification = patch(_requestConfigReadNotification ?? {});
}

let _requestConfigGetPushTokens: Partial<AxiosRequestConfig> | null;
export function getGetPushTokensRequestConfig() {
  return _requestConfigGetPushTokens;
}
export function setGetPushTokensRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPushTokens = value;
}
export function patchGetPushTokensRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPushTokens = patch(_requestConfigGetPushTokens ?? {});
}

let _requestConfigSavePushToken: Partial<AxiosRequestConfig> | null;
export function getSavePushTokenRequestConfig() {
  return _requestConfigSavePushToken;
}
export function setSavePushTokenRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavePushToken = value;
}
export function patchSavePushTokenRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavePushToken = patch(_requestConfigSavePushToken ?? {});
}

let _requestConfigDeletePushToken: Partial<AxiosRequestConfig> | null;
export function getDeletePushTokenRequestConfig() {
  return _requestConfigDeletePushToken;
}
export function setDeletePushTokenRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeletePushToken = value;
}
export function patchDeletePushTokenRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeletePushToken = patch(_requestConfigDeletePushToken ?? {});
}